(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4489],{

/***/ 47037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isArray = __webpack_require__(1469),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ 52353:
/***/ (function(module) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),

/***/ 24525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ auth_ResetPasswordForm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-property.js
var es_object_define_property = __webpack_require__(69070);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(30489);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__(68304);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(88674);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(77601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/lodash/isUndefined.js
var isUndefined = __webpack_require__(52353);
var isUndefined_default = /*#__PURE__*/__webpack_require__.n(isUndefined);
// EXTERNAL MODULE: ./node_modules/lodash/isString.js
var isString = __webpack_require__(47037);
var isString_default = /*#__PURE__*/__webpack_require__.n(isString);
// EXTERNAL MODULE: ./node_modules/lodash/isNil.js
var isNil = __webpack_require__(14293);
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__(73210);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.js
var web_url = __webpack_require__(60285);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.to-json.js
var web_url_to_json = __webpack_require__(83753);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.js
var web_url_search_params = __webpack_require__(41637);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/ValidatedTextInput/ValidatedTextInput.js + 10 modules
var ValidatedTextInput = __webpack_require__(60869);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25923);
// EXTERNAL MODULE: ./node_modules/url-polyfill/url-polyfill.js
var url_polyfill = __webpack_require__(38264);
// EXTERNAL MODULE: ./node_modules/url-search-params-polyfill/index.js
var url_search_params_polyfill = __webpack_require__(35449);
// EXTERNAL MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/CheckEmailForm.mjs
var CheckEmailForm = __webpack_require__(21250);
;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/ResetPasswordErrorMessage.mjs
function cov_qbqrx0c9b() {
    var path = "/home/runner/_work/code/code/js/packages/cinderblocks/src/platform/auth/ResetPasswordErrorMessage.tsx";
    var hash = "72d6ae7eca8eb88a3bd37838ac28a63178bcdb54";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/home/runner/_work/code/code/js/packages/cinderblocks/src/platform/auth/ResetPasswordErrorMessage.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 9,
                    column: 5
                },
                end: {
                    line: 35,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 10,
                    column: 2
                },
                end: {
                    line: 20,
                    column: 3
                }
            },
            "2": {
                start: {
                    line: 11,
                    column: 4
                },
                end: {
                    line: 19,
                    column: 6
                }
            },
            "3": {
                start: {
                    line: 22,
                    column: 2
                },
                end: {
                    line: 32,
                    column: 3
                }
            },
            "4": {
                start: {
                    line: 23,
                    column: 4
                },
                end: {
                    line: 31,
                    column: 6
                }
            },
            "5": {
                start: {
                    line: 34,
                    column: 2
                },
                end: {
                    line: 34,
                    column: 14
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 9,
                        column: 5
                    },
                    end: {
                        line: 9,
                        column: 6
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 57
                    },
                    end: {
                        line: 35,
                        column: 1
                    }
                },
                line: 9
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 10,
                        column: 2
                    },
                    end: {
                        line: 20,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 10,
                            column: 2
                        },
                        end: {
                            line: 20,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 10
            },
            "1": {
                loc: {
                    start: {
                        line: 10,
                        column: 6
                    },
                    end: {
                        line: 10,
                        column: 33
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 10,
                            column: 6
                        },
                        end: {
                            line: 10,
                            column: 11
                        }
                    },
                    {
                        start: {
                            line: 10,
                            column: 15
                        },
                        end: {
                            line: 10,
                            column: 33
                        }
                    }
                ],
                line: 10
            },
            "2": {
                loc: {
                    start: {
                        line: 22,
                        column: 2
                    },
                    end: {
                        line: 32,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 22,
                            column: 2
                        },
                        end: {
                            line: 32,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 22
            },
            "3": {
                loc: {
                    start: {
                        line: 22,
                        column: 6
                    },
                    end: {
                        line: 22,
                        column: 30
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 22,
                            column: 6
                        },
                        end: {
                            line: 22,
                            column: 11
                        }
                    },
                    {
                        start: {
                            line: 22,
                            column: 15
                        },
                        end: {
                            line: 22,
                            column: 30
                        }
                    }
                ],
                line: 22
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0
        },
        f: {
            "0": 0
        },
        b: {
            "0": [
                0,
                0
            ],
            "1": [
                0,
                0
            ],
            "2": [
                0,
                0
            ],
            "3": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "72d6ae7eca8eb88a3bd37838ac28a63178bcdb54"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_qbqrx0c9b = function cov_qbqrx0c9b() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_qbqrx0c9b();


cov_qbqrx0c9b().s[0]++;
var ResetPasswordErrorMessage = function ResetPasswordErrorMessage(_ref) {
    var email = _ref.email, resetPasswordError = _ref.resetPasswordError, hasUnknownEmail = _ref.hasUnknownEmail;
    cov_qbqrx0c9b().f[0]++;
    cov_qbqrx0c9b().s[1]++;
    if ((cov_qbqrx0c9b().b[1][0]++, email) && (cov_qbqrx0c9b().b[1][1]++, resetPasswordError)) {
        cov_qbqrx0c9b().b[0][0]++;
        cov_qbqrx0c9b().s[2]++;
        return /*#__PURE__*/ react.createElement(Text/* Text */.x, {
            tag: "p",
            typography: "$bodyMedium",
            color: "$contentStateErrorDefault"
        }, "Looks like we weren’t able to reset the password for", " ", /*#__PURE__*/ react.createElement(Text/* Text */.x, {
            tag: "strong",
            typography: "$bodyMedium",
            fontWeight: "$medium",
            ml: "$1x"
        }, email), ". Try again later.");
    } else {
        cov_qbqrx0c9b().b[0][1]++;
    }
    cov_qbqrx0c9b().s[3]++;
    if ((cov_qbqrx0c9b().b[3][0]++, email) && (cov_qbqrx0c9b().b[3][1]++, hasUnknownEmail)) {
        cov_qbqrx0c9b().b[2][0]++;
        cov_qbqrx0c9b().s[4]++;
        return /*#__PURE__*/ react.createElement(Text/* Text */.x, {
            tag: "p",
            typography: "$bodyMedium",
            color: "$contentStateErrorDefault"
        }, "Looks like we don’t recognize", " ", /*#__PURE__*/ react.createElement(Text/* Text */.x, {
            tag: "strong",
            typography: "$bodyMedium",
            fontWeight: "$medium",
            ml: "$1x"
        }, email), ". Try again with another email.");
    } else {
        cov_qbqrx0c9b().b[2][1]++;
    }
    cov_qbqrx0c9b().s[5]++;
    return null;
};
/* harmony default export */ var auth_ResetPasswordErrorMessage = (ResetPasswordErrorMessage); //# sourceMappingURL=ResetPasswordErrorMessage.mjs.map

// EXTERNAL MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/shared.mjs
var shared = __webpack_require__(68759);
;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/ResetPasswordForm.mjs

















function cov_2owe32lrqt() {
    var path = "/home/runner/_work/code/code/js/packages/cinderblocks/src/platform/auth/ResetPasswordForm.tsx";
    var hash = "b8fd7eefa05ca361a15e3c652e5c2153a7f553f9";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/home/runner/_work/code/code/js/packages/cinderblocks/src/platform/auth/ResetPasswordForm.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 27,
                    column: 61
                },
                end: {
                    line: 147,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 37,
                    column: 28
                },
                end: {
                    line: 37,
                    column: 58
                }
            },
            "2": {
                start: {
                    line: 39,
                    column: 42
                },
                end: {
                    line: 39,
                    column: 60
                }
            },
            "3": {
                start: {
                    line: 41,
                    column: 38
                },
                end: {
                    line: 41,
                    column: 62
                }
            },
            "4": {
                start: {
                    line: 43,
                    column: 28
                },
                end: {
                    line: 43,
                    column: 79
                }
            },
            "5": {
                start: {
                    line: 45,
                    column: 38
                },
                end: {
                    line: 45,
                    column: 59
                }
            },
            "6": {
                start: {
                    line: 47,
                    column: 47
                },
                end: {
                    line: 47,
                    column: 97
                }
            },
            "7": {
                start: {
                    line: 49,
                    column: 28
                },
                end: {
                    line: 57,
                    column: 3
                }
            },
            "8": {
                start: {
                    line: 50,
                    column: 16
                },
                end: {
                    line: 50,
                    column: 45
                }
            },
            "9": {
                start: {
                    line: 51,
                    column: 19
                },
                end: {
                    line: 51,
                    column: 56
                }
            },
            "10": {
                start: {
                    line: 52,
                    column: 25
                },
                end: {
                    line: 52,
                    column: 44
                }
            },
            "11": {
                start: {
                    line: 54,
                    column: 4
                },
                end: {
                    line: 56,
                    column: 5
                }
            },
            "12": {
                start: {
                    line: 55,
                    column: 6
                },
                end: {
                    line: 55,
                    column: 36
                }
            },
            "13": {
                start: {
                    line: 59,
                    column: 2
                },
                end: {
                    line: 61,
                    column: 9
                }
            },
            "14": {
                start: {
                    line: 60,
                    column: 4
                },
                end: {
                    line: 60,
                    column: 24
                }
            },
            "15": {
                start: {
                    line: 63,
                    column: 2
                },
                end: {
                    line: 67,
                    column: 14
                }
            },
            "16": {
                start: {
                    line: 64,
                    column: 4
                },
                end: {
                    line: 66,
                    column: 5
                }
            },
            "17": {
                start: {
                    line: 65,
                    column: 6
                },
                end: {
                    line: 65,
                    column: 29
                }
            },
            "18": {
                start: {
                    line: 69,
                    column: 19
                },
                end: {
                    line: 75,
                    column: 3
                }
            },
            "19": {
                start: {
                    line: 71,
                    column: 6
                },
                end: {
                    line: 71,
                    column: 87
                }
            },
            "20": {
                start: {
                    line: 72,
                    column: 4
                },
                end: {
                    line: 74,
                    column: 5
                }
            },
            "21": {
                start: {
                    line: 73,
                    column: 6
                },
                end: {
                    line: 73,
                    column: 30
                }
            },
            "22": {
                start: {
                    line: 77,
                    column: 27
                },
                end: {
                    line: 82,
                    column: 3
                }
            },
            "23": {
                start: {
                    line: 78,
                    column: 4
                },
                end: {
                    line: 78,
                    column: 23
                }
            },
            "24": {
                start: {
                    line: 79,
                    column: 4
                },
                end: {
                    line: 81,
                    column: 5
                }
            },
            "25": {
                start: {
                    line: 80,
                    column: 6
                },
                end: {
                    line: 80,
                    column: 42
                }
            },
            "26": {
                start: {
                    line: 84,
                    column: 2
                },
                end: {
                    line: 93,
                    column: 3
                }
            },
            "27": {
                start: {
                    line: 85,
                    column: 4
                },
                end: {
                    line: 92,
                    column: 6
                }
            },
            "28": {
                start: {
                    line: 94,
                    column: 2
                },
                end: {
                    line: 146,
                    column: 4
                }
            },
            "29": {
                start: {
                    line: 109,
                    column: 48
                },
                end: {
                    line: 109,
                    column: 85
                }
            },
            "30": {
                start: {
                    line: 110,
                    column: 33
                },
                end: {
                    line: 110,
                    column: 65
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 27,
                        column: 61
                    },
                    end: {
                        line: 27,
                        column: 62
                    }
                },
                loc: {
                    start: {
                        line: 36,
                        column: 6
                    },
                    end: {
                        line: 147,
                        column: 1
                    }
                },
                line: 36
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 49,
                        column: 28
                    },
                    end: {
                        line: 49,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 49,
                        column: 34
                    },
                    end: {
                        line: 57,
                        column: 3
                    }
                },
                line: 49
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 59,
                        column: 12
                    },
                    end: {
                        line: 59,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 59,
                        column: 18
                    },
                    end: {
                        line: 61,
                        column: 3
                    }
                },
                line: 59
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 63,
                        column: 12
                    },
                    end: {
                        line: 63,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 63,
                        column: 18
                    },
                    end: {
                        line: 67,
                        column: 3
                    }
                },
                line: 63
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 69,
                        column: 19
                    },
                    end: {
                        line: 69,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 69,
                        column: 30
                    },
                    end: {
                        line: 75,
                        column: 3
                    }
                },
                line: 69
            },
            "5": {
                name: "(anonymous_5)",
                decl: {
                    start: {
                        line: 77,
                        column: 27
                    },
                    end: {
                        line: 77,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 77,
                        column: 40
                    },
                    end: {
                        line: 82,
                        column: 3
                    }
                },
                line: 77
            },
            "6": {
                name: "(anonymous_6)",
                decl: {
                    start: {
                        line: 109,
                        column: 32
                    },
                    end: {
                        line: 109,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 109,
                        column: 48
                    },
                    end: {
                        line: 109,
                        column: 85
                    }
                },
                line: 109
            },
            "7": {
                name: "(anonymous_7)",
                decl: {
                    start: {
                        line: 110,
                        column: 22
                    },
                    end: {
                        line: 110,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 110,
                        column: 33
                    },
                    end: {
                        line: 110,
                        column: 65
                    }
                },
                line: 110
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 28,
                        column: 9
                    },
                    end: {
                        line: 28,
                        column: 26
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 28,
                            column: 24
                        },
                        end: {
                            line: 28,
                            column: 26
                        }
                    }
                ],
                line: 28
            },
            "1": {
                loc: {
                    start: {
                        line: 31,
                        column: 2
                    },
                    end: {
                        line: 31,
                        column: 30
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 31,
                            column: 25
                        },
                        end: {
                            line: 31,
                            column: 30
                        }
                    }
                ],
                line: 31
            },
            "2": {
                loc: {
                    start: {
                        line: 32,
                        column: 2
                    },
                    end: {
                        line: 32,
                        column: 20
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 32,
                            column: 15
                        },
                        end: {
                            line: 32,
                            column: 20
                        }
                    }
                ],
                line: 32
            },
            "3": {
                loc: {
                    start: {
                        line: 33,
                        column: 2
                    },
                    end: {
                        line: 33,
                        column: 17
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 33,
                            column: 12
                        },
                        end: {
                            line: 33,
                            column: 17
                        }
                    }
                ],
                line: 33
            },
            "4": {
                loc: {
                    start: {
                        line: 43,
                        column: 28
                    },
                    end: {
                        line: 43,
                        column: 79
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 43,
                            column: 28
                        },
                        end: {
                            line: 43,
                            column: 40
                        }
                    },
                    {
                        start: {
                            line: 43,
                            column: 44
                        },
                        end: {
                            line: 43,
                            column: 67
                        }
                    },
                    {
                        start: {
                            line: 43,
                            column: 71
                        },
                        end: {
                            line: 43,
                            column: 79
                        }
                    }
                ],
                line: 43
            },
            "5": {
                loc: {
                    start: {
                        line: 45,
                        column: 38
                    },
                    end: {
                        line: 45,
                        column: 59
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 45,
                            column: 38
                        },
                        end: {
                            line: 45,
                            column: 48
                        }
                    },
                    {
                        start: {
                            line: 45,
                            column: 52
                        },
                        end: {
                            line: 45,
                            column: 59
                        }
                    }
                ],
                line: 45
            },
            "6": {
                loc: {
                    start: {
                        line: 47,
                        column: 47
                    },
                    end: {
                        line: 47,
                        column: 97
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 47,
                            column: 47
                        },
                        end: {
                            line: 47,
                            column: 57
                        }
                    },
                    {
                        start: {
                            line: 47,
                            column: 61
                        },
                        end: {
                            line: 47,
                            column: 71
                        }
                    },
                    {
                        start: {
                            line: 47,
                            column: 75
                        },
                        end: {
                            line: 47,
                            column: 97
                        }
                    }
                ],
                line: 47
            },
            "7": {
                loc: {
                    start: {
                        line: 54,
                        column: 4
                    },
                    end: {
                        line: 56,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 54,
                            column: 4
                        },
                        end: {
                            line: 56,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 54
            },
            "8": {
                loc: {
                    start: {
                        line: 64,
                        column: 4
                    },
                    end: {
                        line: 66,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 64,
                            column: 4
                        },
                        end: {
                            line: 66,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 64
            },
            "9": {
                loc: {
                    start: {
                        line: 71,
                        column: 6
                    },
                    end: {
                        line: 71,
                        column: 87
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 71,
                            column: 63
                        },
                        end: {
                            line: 71,
                            column: 72
                        }
                    },
                    {
                        start: {
                            line: 71,
                            column: 75
                        },
                        end: {
                            line: 71,
                            column: 87
                        }
                    }
                ],
                line: 71
            },
            "10": {
                loc: {
                    start: {
                        line: 71,
                        column: 6
                    },
                    end: {
                        line: 71,
                        column: 60
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 71,
                            column: 6
                        },
                        end: {
                            line: 71,
                            column: 18
                        }
                    },
                    {
                        start: {
                            line: 71,
                            column: 22
                        },
                        end: {
                            line: 71,
                            column: 40
                        }
                    },
                    {
                        start: {
                            line: 71,
                            column: 44
                        },
                        end: {
                            line: 71,
                            column: 60
                        }
                    }
                ],
                line: 71
            },
            "11": {
                loc: {
                    start: {
                        line: 72,
                        column: 4
                    },
                    end: {
                        line: 74,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 72,
                            column: 4
                        },
                        end: {
                            line: 74,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 72
            },
            "12": {
                loc: {
                    start: {
                        line: 79,
                        column: 4
                    },
                    end: {
                        line: 81,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 79,
                            column: 4
                        },
                        end: {
                            line: 81,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 79
            },
            "13": {
                loc: {
                    start: {
                        line: 84,
                        column: 2
                    },
                    end: {
                        line: 93,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 84,
                            column: 2
                        },
                        end: {
                            line: 93,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 84
            },
            "14": {
                loc: {
                    start: {
                        line: 84,
                        column: 6
                    },
                    end: {
                        line: 84,
                        column: 64
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 84,
                            column: 6
                        },
                        end: {
                            line: 84,
                            column: 17
                        }
                    },
                    {
                        start: {
                            line: 84,
                            column: 21
                        },
                        end: {
                            line: 84,
                            column: 38
                        }
                    },
                    {
                        start: {
                            line: 84,
                            column: 43
                        },
                        end: {
                            line: 84,
                            column: 53
                        }
                    },
                    {
                        start: {
                            line: 84,
                            column: 57
                        },
                        end: {
                            line: 84,
                            column: 63
                        }
                    }
                ],
                line: 84
            },
            "15": {
                loc: {
                    start: {
                        line: 137,
                        column: 24
                    },
                    end: {
                        line: 137,
                        column: 46
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 137,
                            column: 24
                        },
                        end: {
                            line: 137,
                            column: 35
                        }
                    },
                    {
                        start: {
                            line: 137,
                            column: 39
                        },
                        end: {
                            line: 137,
                            column: 46
                        }
                    }
                ],
                line: 137
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "29": 0,
            "30": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0
        },
        b: {
            "0": [
                0
            ],
            "1": [
                0
            ],
            "2": [
                0
            ],
            "3": [
                0
            ],
            "4": [
                0,
                0,
                0
            ],
            "5": [
                0,
                0
            ],
            "6": [
                0,
                0,
                0
            ],
            "7": [
                0,
                0
            ],
            "8": [
                0,
                0
            ],
            "9": [
                0,
                0
            ],
            "10": [
                0,
                0,
                0
            ],
            "11": [
                0,
                0
            ],
            "12": [
                0,
                0
            ],
            "13": [
                0,
                0
            ],
            "14": [
                0,
                0,
                0,
                0
            ],
            "15": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "b8fd7eefa05ca361a15e3c652e5c2153a7f553f9"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_2owe32lrqt = function cov_2owe32lrqt() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_2owe32lrqt();
function _regenerator() {
    var i = function i(r, n, o, i1) {
        var c = n && (0,_instanceof/* default */.Z)(n.prototype, Generator) ? n : Generator, u = Object.create(c.prototype);
        return _regeneratorDefine2(u, "_invoke", function(r, n, o) {
            var _$i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return _$i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !_$o && t < p.length; t++){
                    var _$o, _$i = p[t], _$d = G.p, l = _$i[2];
                    r > 3 ? (_$o = l === n) && (u = _$i[(c = _$i[4]) ? 5 : (c = 3, 3)], _$i[4] = _$i[5] = e) : _$i[0] <= _$d && ((_$o = r < 2 && _$d < _$i[1]) ? (c = 0, G.v = n, G.n = _$i[1]) : _$d < l && (_$o = r < 3 || _$i[0] > n || n > l) && (_$i[4] = r, _$i[5] = n, G.n = l, c = 0));
                }
                if (_$o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    _$i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, _$i) {
                            if (c || (o = "next"), t = _$i[o]) {
                                if (!(t = t.call(_$i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = _$i["return"]) && t.call(_$i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            _$i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t1) {
                        _$i = e, c = 1, u = t1;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i1), !0), u;
    };
    var Generator = function Generator() {};
    var GeneratorFunction = function GeneratorFunction() {};
    var GeneratorFunctionPrototype = function GeneratorFunctionPrototype() {};
    var f = function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    };
    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    var a = {};
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function() {
        return this;
    }), _regeneratorDefine2(u, "toString", function() {
        return "[object Generator]";
    }), (_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    })();
}
function _regeneratorDefine2(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e1) {
        i = 0;
    }
    _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
        var o = function o(r, n) {
            _regeneratorDefine2(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        };
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n1) {
        return void e(n1);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}








function _slicedToArray(r, e) {
    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r1) {
            o = !0, n = r1;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}







cov_2owe32lrqt().s[0]++;
var ResetPasswordForm = function ResetPasswordForm(_ref) {
    var _ref$email = _ref.email, initialEmail = _ref$email === void 0 ? (cov_2owe32lrqt().b[0][0]++, "") : _ref$email, error = _ref.error, analyticsName = _ref.analyticsName, _ref$hasGeneratedPass = _ref.hasGeneratedPassword, hasGeneratedPassword = _ref$hasGeneratedPass === void 0 ? (cov_2owe32lrqt().b[1][0]++, false) : _ref$hasGeneratedPass, _ref$isNewHuman = _ref.isNewHuman, isNewHuman = _ref$isNewHuman === void 0 ? (cov_2owe32lrqt().b[2][0]++, false) : _ref$isNewHuman, _ref$loading = _ref.loading, loading = _ref$loading === void 0 ? (cov_2owe32lrqt().b[3][0]++, false) : _ref$loading, onPasswordResetSuccess = _ref.onPasswordResetSuccess, onRequestResetPassword = _ref.onRequestResetPassword;
    cov_2owe32lrqt().f[0]++;
    var _ref2 = (cov_2owe32lrqt().s[1]++, (0,react.useState)(initialEmail)), _ref3 = _slicedToArray(_ref2, 2), email = _ref3[0], setEmail = _ref3[1];
    var _ref4 = (cov_2owe32lrqt().s[2]++, (0,react.useState)()), _ref5 = _slicedToArray(_ref4, 2), prefillEmail = _ref5[0], setPrefillEmail = _ref5[1];
    var _ref6 = (cov_2owe32lrqt().s[3]++, (0,react.useState)(false)), _ref7 = _slicedToArray(_ref6, 2), validEmail = _ref7[0], setValidEmail = _ref7[1];
    var hasSubmittedEmail = (cov_2owe32lrqt().s[4]++, (cov_2owe32lrqt().b[4][0]++, initialEmail) && (cov_2owe32lrqt().b[4][1]++, initialEmail.length > 0) && (cov_2owe32lrqt().b[4][2]++, !loading));
    var shouldShowResetErrorMessage = (cov_2owe32lrqt().s[5]++, (cov_2owe32lrqt().b[5][0]++, validEmail) && (cov_2owe32lrqt().b[5][1]++, !!error));
    var shouldShowUnrecognizableEmailMessage = (cov_2owe32lrqt().s[6]++, (cov_2owe32lrqt().b[6][0]++, validEmail) && (cov_2owe32lrqt().b[6][1]++, isNewHuman) && (cov_2owe32lrqt().b[6][2]++, initialEmail === email));
    cov_2owe32lrqt().s[7]++;
    var maybePrefillEmail = function maybePrefillEmail() {
        cov_2owe32lrqt().f[1]++;
        var url = (cov_2owe32lrqt().s[8]++, new URL(window.location.href));
        var params = (cov_2owe32lrqt().s[9]++, new URLSearchParams(url.searchParams));
        var prefillEmail = (cov_2owe32lrqt().s[10]++, params.get("email"));
        cov_2owe32lrqt().s[11]++;
        if (prefillEmail) {
            cov_2owe32lrqt().b[7][0]++;
            cov_2owe32lrqt().s[12]++;
            setPrefillEmail(prefillEmail);
        } else {
            cov_2owe32lrqt().b[7][1]++;
        }
    };
    cov_2owe32lrqt().s[13]++;
    (0,react.useEffect)(function() {
        cov_2owe32lrqt().f[2]++;
        cov_2owe32lrqt().s[14]++;
        maybePrefillEmail();
    }, []);
    cov_2owe32lrqt().s[15]++;
    (0,react.useEffect)(function() {
        cov_2owe32lrqt().f[3]++;
        cov_2owe32lrqt().s[16]++;
        if (error) {
            cov_2owe32lrqt().b[8][0]++;
            cov_2owe32lrqt().s[17]++;
            setValidEmail(!!error);
        } else {
            cov_2owe32lrqt().b[8][1]++;
        }
    }, [
        error
    ]);
    cov_2owe32lrqt().s[18]++;
    var onChange = function onChange(value) {
        cov_2owe32lrqt().f[4]++;
        var onChangeEmail = (cov_2owe32lrqt().s[19]++, (cov_2owe32lrqt().b[10][0]++, isNil_default()(value)) || (cov_2owe32lrqt().b[10][1]++, isUndefined_default()(value)) || (cov_2owe32lrqt().b[10][2]++, !isString_default()(value)) ? (cov_2owe32lrqt().b[9][0]++, undefined) : (cov_2owe32lrqt().b[9][1]++, value.trim()));
        cov_2owe32lrqt().s[20]++;
        if (onChangeEmail !== email) {
            cov_2owe32lrqt().b[11][0]++;
            cov_2owe32lrqt().s[21]++;
            setEmail(onChangeEmail);
        } else {
            cov_2owe32lrqt().b[11][1]++;
        }
    };
    cov_2owe32lrqt().s[22]++;
    var handleFormSubmit = /*#__PURE__*/ function() {
        var _ref8 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee(e) {
            return _regenerator().w(function(_context) {
                while(1)switch(_context.n){
                    case 0:
                        cov_2owe32lrqt().f[5]++;
                        cov_2owe32lrqt().s[23]++;
                        e.preventDefault();
                        cov_2owe32lrqt().s[24]++;
                        if (!validEmail) {
                            _context.n = 2;
                            break;
                        }
                        cov_2owe32lrqt().b[12][0]++;
                        cov_2owe32lrqt().s[25]++;
                        _context.n = 1;
                        return onRequestResetPassword(email);
                    case 1:
                        _context.n = 3;
                        break;
                    case 2:
                        cov_2owe32lrqt().b[12][1]++;
                    case 3:
                        return _context.a(2);
                }
            }, _callee);
        }));
        return function handleFormSubmit(_x) {
            return _ref8.apply(this, arguments);
        };
    }();
    cov_2owe32lrqt().s[26]++;
    if ((cov_2owe32lrqt().b[14][0]++, !isNewHuman) && (cov_2owe32lrqt().b[14][1]++, hasSubmittedEmail) && ((cov_2owe32lrqt().b[14][2]++, validEmail) || (cov_2owe32lrqt().b[14][3]++, !error))) {
        cov_2owe32lrqt().b[13][0]++;
        cov_2owe32lrqt().s[27]++;
        return /*#__PURE__*/ react.createElement(CheckEmailForm/* default */.Z, {
            analyticsName: analyticsName,
            email: email,
            hasGeneratedPassword: hasGeneratedPassword,
            onResetValidEmail: onPasswordResetSuccess
        });
    } else {
        cov_2owe32lrqt().b[13][1]++;
    }
    cov_2owe32lrqt().s[28]++;
    return /*#__PURE__*/ react.createElement(shared/* Form */.l0, {
        onSubmit: handleFormSubmit
    }, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        gap: "$20x"
    }, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        width: "100%",
        gap: "$10x"
    }, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "h1",
        typography: "$headerMedium",
        textAlign: "left"
    }, "Trouble logging in?"), /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "p",
        typography: "$bodySmall",
        textAlign: "left"
    }, "Enter your email and we’ll send a link to reset your password.")), /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        width: "100%"
    }, /*#__PURE__*/ react.createElement(ValidatedTextInput/* ValidatedTextInput */.O, {
        id: "reset-password-input",
        prefilledValue: prefillEmail,
        onValidationChange: function onValidationChange(validation) {
            cov_2owe32lrqt().f[6]++;
            cov_2owe32lrqt().s[29]++;
            return setValidEmail(validation === "valid");
        },
        getValue: function getValue(value) {
            cov_2owe32lrqt().f[7]++;
            cov_2owe32lrqt().s[30]++;
            return onChange(value.unformattedValue);
        },
        size: "small",
        format: "emailAddress",
        title: "Email",
        required: true,
        allowSuggestions: true,
        customErrorMessages: {
            fieldRequired: "This field cannot be empty.",
            invalidEmail: "Looks like this isn’t a valid email."
        }
    }), /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        my: "$4x",
        style: {
            textAlign: "center"
        }
    }, /*#__PURE__*/ react.createElement(auth_ResetPasswordErrorMessage, {
        email: email,
        resetPasswordError: shouldShowResetErrorMessage,
        hasUnknownEmail: shouldShowUnrecognizableEmailMessage
    })), /*#__PURE__*/ react.createElement(Box/* Box */.x, null, /*#__PURE__*/ react.createElement(Button/* Button */.z, {
        "data-test-id": "send-reset-password-instructions",
        width: "100%",
        size: "small",
        variant: "primary",
        type: "submit",
        label: "Send",
        loading: loading,
        disabled: (cov_2owe32lrqt().b[15][0]++, !validEmail) || (cov_2owe32lrqt().b[15][1]++, loading),
        onPress: handleFormSubmit,
        analyticsName: "".concat(analyticsName, "-send-me-instructions"),
        "aria-label": "Send instructions to reset your password"
    })))));
};
/* harmony default export */ var auth_ResetPasswordForm = (ResetPasswordForm); //# sourceMappingURL=ResetPasswordForm.mjs.map


/***/ }),

/***/ 71390:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var railsEnv_1 = __webpack_require__(27825);
var faviconPath = function (_a) {
    var _b = _a === void 0 ? {} : _a, admin = _b.admin, railsEnv = _b.railsEnv;
    var env = railsEnv || (0, railsEnv_1.getRailsEnv)();
    // these favicons created in this Figma document
    // https://www.figma.com/file/R2a9eL6fEQMq24CY2Q8752NB/Favicons?node-id=19%3A29
    if (admin) {
        if (env === 'development') {
            return 'https://images.opendoor.com/source/s3/imgdrop-production/1bd03e41b990465e93d1c5b90ba36c16.png?service=shared-fe&preset=square-48';
        }
        else if (env === 'staging') {
            return 'https://images.opendoor.com/source/s3/imgdrop-production/a8dddd737aeb4780bf9e8edfa8bdc27b.png?service=shared-fe&preset=square-48';
        }
        else if (env === 'qa') {
            return 'https://images.opendoor.com/source/s3/imgdrop-production/28c43a220c9247f1ba3764c6aa7f67b3.png?service=shared-fe&preset=square-48';
        }
        return 'https://images.opendoor.com/source/s3/imgdrop-production/6f05fac182304e3d821592580acf3a68.png?service=shared-fe&preset=square-48';
    }
    if (env === 'development') {
        return 'https://images.opendoor.com/source/s3/imgdrop-production/4ec068f491b4478293d83b56911a2f65.png?service=shared-fe&preset=square-48';
    }
    else if (env === 'staging') {
        return 'https://images.opendoor.com/source/s3/imgdrop-production/006a1ec0195a4e95bea9bd906d99130c.png?service=shared-fe&preset=square-48';
    }
    else if (env === 'qa') {
        return 'https://images.opendoor.com/source/s3/imgdrop-production/5618f1f758be4937861351a1c96548d6.png?service=shared-fe&preset=square-48';
    }
    return 'https://images.opendoor.com/source/s3/imgdrop-production/cf88fd37a91e43b0b7aafe6b076d2810.png?service=shared-fe&preset=square-48';
};
exports.Z = faviconPath;


/***/ })

}]);